import { memo, useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlMarket } from "../../models/domain/Market";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';

export type MarketTableProps = {
    dataSource?: mdlMarket[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    rowSelectionChange?: Function;
}

export const MarketTable = memo(function MarketTable(props: MarketTableProps) {
    const { t } = useTranslation();
    const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>('checkbox');

    useEffect(() => {
    }, [props]);

    const rowSelection: TableProps<mdlMarket>['rowSelection'] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: mdlMarket[]) => {
            props.rowSelectionChange && props.rowSelectionChange(selectedRows);
        },
    };

    const columns: TableProps<mdlMarket>['columns'] = [
        {
            title: t("definitions.markets.name"),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t("definitions.markets.isPublished"),
            key: 'isPublished',
            render: (e: mdlMarket) => {
                return e.isPublished ? <Tag color="green">
                    {t("definitions.markets.published")}
                </Tag>
                    :
                    <Tag color="orange">
                        {t("definitions.markets.draft")}
                    </Tag>
            }
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" className="btn-success" onClick={() => props.onEdit ? props.onEdit(record.id) : undefined}>
                        {t("common.edit")}
                    </Button>
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleRowDoubleClick = (e: React.MouseEvent<HTMLInputElement>, market: mdlMarket) => {
        if (!$(e.target).hasClass("ant-table-row-expand-icon"))
            props.onEdit && props.onEdit(market.id);
    }

    const handleTableChange: TableProps<mdlMarket>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlMarket>
                    onRow={(reservation) => ({
                        onDoubleClick: (e) => handleRowDoubleClick(e, reservation),
                    })}
                    onChange={handleTableChange}
                    size="middle"
                    columns={columns}
                    pagination={props.pagination}
                    scroll={{ x: 'max-content' }}
                    dataSource={props.dataSource.map((market: mdlMarket, index: number) => ({ ...market, key: index }))}
                    rowSelection={{ type: selectionType, ...rowSelection }}
                />
            }
        </>
    )
})